var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Headers } from '@angular/http';
import * as JSZip from 'jszip';
import * as FileSaver from 'file-saver';
import { Api } from 'app/core/api.service';
import { ResponseContentType, Http } from '@angular/http';
export function isIE() {
    return navigator.userAgent.indexOf('Trident') >= 0;
}
export function isEdge() {
    return navigator.userAgent.indexOf('Edge') >= 0;
}
/** Скачивает файл с помощью <form> */
function downloadByUrl(url) {
    var form = document.createElement('form');
    form.setAttribute('action', url);
    form.setAttribute('method', 'GET');
    if (isIE() || isEdge()) {
        form.setAttribute('target', '_blank');
    }
    form.style.display = 'none';
    document.body.appendChild(form);
    form.submit();
    setTimeout(function () { return document.body.removeChild(form); }, 1000);
}
/** Сервис скачивания файлов */
var DownloadService = /** @class */ (function () {
    function DownloadService(_http, _api) {
        this._http = _http;
        this._api = _api;
    }
    /** Скачивает файл */
    DownloadService.prototype.file = function (file, applicationId) {
        return __awaiter(this, void 0, void 0, function () {
            var blob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBlob(file, applicationId)];
                    case 1:
                        blob = _a.sent();
                        FileSaver.saveAs(blob, file.name);
                        return [2 /*return*/];
                }
            });
        });
    };
    // /** Скачивает zip-архив с файлами */
    DownloadService.prototype.archive = function (files, archiveName, applicationId) {
        return __awaiter(this, void 0, void 0, function () {
            var jszip, promises, content;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jszip = new JSZip();
                        promises = files.map(function (file) { return __awaiter(_this, void 0, void 0, function () {
                            var blob;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getBlob(file, applicationId)];
                                    case 1:
                                        blob = _a.sent();
                                        jszip.file(file.name, blob);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, jszip.generateAsync({ type: 'blob' })];
                    case 2:
                        content = _a.sent();
                        FileSaver.saveAs(content, archiveName);
                        return [2 /*return*/];
                }
            });
        });
    };
    DownloadService.prototype.download = function (url, applicationId) {
        return __awaiter(this, void 0, void 0, function () {
            var options, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            headers: new Headers({
                                Authorization: this._api.getAuthorizationHeader(),
                                'ACS-Application': applicationId
                            }),
                            responseType: ResponseContentType.Blob
                        };
                        return [4 /*yield*/, this._http.get(url, options).toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.blob()];
                }
            });
        });
    };
    DownloadService.prototype.getBlob = function (file, applicationId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/api/v2/file/" + file.id + "/" + file.token;
                return [2 /*return*/, this.download(url, applicationId)];
            });
        });
    };
    return DownloadService;
}());
export { DownloadService };
